import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "printer-information row" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 col-sm-6 q-pr-xl printer-select"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "q-mb-sm"
}
const _hoisted_5 = { class: "card-title q-mb-sm" }
const _hoisted_6 = {
  key: 0,
  class: "card-title"
}
const _hoisted_7 = {
  key: 1,
  class: "col-12 col-sm-6"
}
const _hoisted_8 = { class: "add-printer col-12 col-sm-6 q-pl-xl" }
const _hoisted_9 = ["onDblclick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "label-boxes" }
const _hoisted_13 = { class: "label-box" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "printers" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "card-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron_right_icon = _resolveComponent("chevron-right-icon")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block_select = _resolveComponent("editable-block-select")!
  const _component_editable_block = _resolveComponent("editable-block")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.printers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Printers", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printers, (printer) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["printer-card q-mb-sm", { 'active': printer.sys.id === _ctx.activePrinter.sys.id }]),
                onClick: ($event: any) => (_ctx.setActivePrinter(printer.sys.id))
              }, [
                (printer.type)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.getDisplayValue(_ctx.printerTypeOptions, printer.type)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h5", _hoisted_5, _toDisplayString(printer.name), 1),
                (printer.status)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["label", printer.status])
                    }, _toDisplayString(printer.status), 3))
                  : _createCommentVNode("", true),
                (printer.sys.id !== _ctx.activePrinter.sys.id)
                  ? (_openBlock(), _createBlock(_component_chevron_right_icon, {
                      key: 2,
                      class: "open",
                      size: "22px"
                    }))
                  : (_openBlock(), _createBlock(_component_trash_icon, {
                      key: 3,
                      class: "remove",
                      onClick: ($event: any) => (_ctx.handleRemovePrinter(printer)),
                      size: "22px"
                    }, null, 8, ["onClick"]))
              ], 10, _hoisted_3))
            }), 256)),
            (_ctx.printers.length === 0)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_6, "No printers found"))
              : _createCommentVNode("", true),
            _createVNode(_component_q_btn, {
              class: "q-mt-md",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addPrinterModal = true)),
              unelevated: "",
              rounded: "",
              outline: ""
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "t-icon lowercase" }, "k", -1),
                _createElementVNode("span", null, "Add printer", -1)
              ])),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[8] || (_cache[8] = [
            _createElementVNode("h2", null, "Printers could not be loaded", -1)
          ]))),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.activePrinter)
          ? (_openBlock(), _createBlock(_component_editable_block, {
              key: 0,
              "model-value": _ctx.activePrinter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-printer', [$event, _ctx.activePrinter.sys.id]))),
              "onUpdate:editing": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = true)),
              onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editing = false)),
              layout: "grid",
              "remove-block-style": ""
            }, {
              default: _withCtx(({ editState, editingRef }) => [
                _createElementVNode("div", {
                  class: "active-printer",
                  onDblclick: ($event: any) => (editingRef.value = true)
                }, [
                  (!_ctx.editing)
                    ? (_openBlock(), _createBlock(_component_tooltip, {
                        key: 0,
                        "tooltip-value": "Double click to edit",
                        selector: ".active-printer"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_editable_block_input, {
                    modelValue: editState.name,
                    "onUpdate:modelValue": ($event: any) => ((editState.name) = $event),
                    label: "Printer name"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_editable_block_input, {
                    modelValue: editState.location,
                    "onUpdate:modelValue": ($event: any) => ((editState.location) = $event),
                    label: "Location"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_editable_block_select, {
                    "model-value": editState.type,
                    "onUpdate:modelValue": ($event: any) => (editState.type = $event.value),
                    options: _ctx.printerTypeOptions,
                    attributes: {'emit-value': true, 'map-options': true},
                    label: "Type"
                  }, {
                    static: _withCtx(({ inputState }) => [
                      (inputState.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getDisplayValue(_ctx.printerTypeOptions, inputState.value)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                    ]),
                    _: 2
                  }, 1032, ["model-value", "onUpdate:modelValue", "options"]),
                  _createVNode(_component_editable_block_select, {
                    "model-value": editState.tags,
                    options: _ctx.channels,
                    attributes: {mapOptions: true, multiple: true, useChips: true, emitValue: true},
                    "onUpdate:modelValue": tags => editState.tags = tags?.map(tag => typeof tag === 'object' ? tag.value : tag),
                    label: "Print for channels"
                  }, {
                    static: _withCtx(({ inputState }) => [
                      _createElementVNode("div", _hoisted_12, [
                        (inputState.value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(inputState.value, (value) => {
                              return (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.getDisplayValue(_ctx.channels, value)), 1))
                            }), 256))
                          : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["model-value", "options", "onUpdate:modelValue"]),
                  _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "card-title" }, "Connection details", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "Computer", -1)),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(editState.meta?.computer?.hostname ? editState.meta?.computer?.hostname : '-'), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label" }, "ID", -1)),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(editState.meta?.computer?.id ? editState.meta?.computer?.id : '-'), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label" }, "Version", -1)),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(editState.meta?.computer?.version ? editState.meta?.computer?.version : '-'), 1)
                ], 40, _hoisted_9)
              ]),
              _: 1
            }, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_dialog, {
      class: "add-printer-dialog",
      modelValue: _ctx.addPrinterModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addPrinterModal) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createElementVNode("h5", { class: "title" }, "Select a printer to be added", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCollection, (printer) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["printer-card", {'active': printer?.sys?.id === _ctx.addedPrinter?.sys?.id}]),
                      onClick: ($event: any) => (_ctx.addedPrinter = printer)
                    }, [
                      _createElementVNode("span", null, _toDisplayString(printer.type), 1),
                      _createElementVNode("h5", _hoisted_20, _toDisplayString(printer.name), 1),
                      (printer.status)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["notice inline dense", printer.status])
                          }, _toDisplayString(printer.status), 3))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_19))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            (_ctx.addedPrinter)
              ? (_openBlock(), _createBlock(_component_q_card_actions, { key: 0 }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('add-printer', _ctx.addedPrinter))),
                      unelevated: "",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_tick_icon, { left: "" }),
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Save", -1))
                      ]),
                      _: 1
                    })), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      class: "q-mr-md",
                      flat: "",
                      unelevated: "",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_close_icon, { left: "" }),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Cancel", -1))
                      ]),
                      _: 1
                    })), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}